"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.listPaths = void 0;
var listPaths_1 = require("./listPaths");
Object.defineProperty(exports, "listPaths", { enumerable: true, get: function () { return listPaths_1.listPaths; } });
